import * as React from 'react';
import { InlineText1 } from '@cian/ui-kit/typography';

export const InfoText = () => {
  return (
    <div>
      <InlineText1>
        Мы не спамим и не передаем номера телефонов третьим лицам. Вам позвонят наиболее подходящие риэлторы. Им покажем
        другой номер телефона, который перенаправит звонок на ваш
      </InlineText1>
    </div>
  );
};

InfoText.displayName = 'InfoText';
